import { render, staticRenderFns } from "./adjustDetailModal.vue?vue&type=template&id=10bfd58c&scoped=true"
import script from "./adjustDetailModal.vue?vue&type=script&lang=js"
export * from "./adjustDetailModal.vue?vue&type=script&lang=js"
import style0 from "./adjustDetailModal.vue?vue&type=style&index=0&id=10bfd58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bfd58c",
  null
  
)

export default component.exports